import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core';
import { LiberarManualDialogComponent } from '../liberar-manual-dialog/liberar-manual-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SnackbarService } from './../../../services/snackbar.service';
import { IGenericContract } from 'src/app/models/generic';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { ApiContractService } from 'src/app/services/api/api-contract.service';
import {
  DialogTypeEnum,
  IDialogConfirm
} from 'src/app/models/dialog';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ContratoEditarComissaoComponent } from '../../../pages/contratos/contrato-editar-comissao/contrato-editar-comissao.component';
import { IManualBatchLiberacao } from '../../../models/manual-batch';

@Component({
  selector: 'app-contratos-footer',
  templateUrl: './contratos-footer.component.html',
  styleUrls: ['./contratos-footer.component.scss']
})
export class ContratosFooterComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() link!: string;
  @Input() showBackButton: boolean = true;
  @Input() appearance: 'legacy' | 'modern' = 'legacy';
  @Input() integratedOnSAP: boolean = false;
  @Input() allowCancelSap: boolean = false;
  @Input() allowIntegrationSap: boolean = false;
  @Input() allowLiberacaoManual: boolean = false;
  @Input() allowReintegrationSap: boolean = false;

  @Input() allowRefreshNFENumber: boolean = false;

  @Input() allowCancelBatch: boolean = false;
  @Input() allowCancelAllContractsBatch: boolean = false;
  @Input() allowReturnStatus: boolean = false;

  @Output() integrateSapEvent = new EventEmitter<unknown>();
  @Output() reSendIntegrateSapEvent = new EventEmitter<unknown>();
  @Output() refreshNFENumberEvent = new EventEmitter<unknown>();
  @Output() requestInvoiceEvent = new EventEmitter<unknown>();
  /*@Output() cancelSapEvent = new EventEmitter<unknown>();*/
  @Output() cancelBatchEvent = new EventEmitter<unknown>();
  @Output() cancelAllContractsBatchEvent = new EventEmitter<boolean>();
  @Output() returnBatchStatusEvent = new EventEmitter<unknown>();
  @Output() viewBatchEventLogEvent = new EventEmitter<unknown>();
  @Output() liberarManualEvent = new EventEmitter<{ payload: IManualBatchLiberacao }>();


  id = '';
  changeStage = false;
  changeCommission = false;
  stageName!: string;
  currentMode = 'visualizar';
  DialogTypeEnum = DialogTypeEnum;
  route!: string;
  contractData!: IGenericContract;

  private contractNumber = '';
  private queryNumber = '';
  private financialInstitution = '';

  subs: Subscription[] = [];

  constructor(
    private _dialog: MatDialog,
    private _dialogService: ApiDialogService,
    private _contractService: ApiContractService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _snackbarService: SnackbarService,
    private _cd: ChangeDetectorRef
  ) {
    this.id = _activatedRoute.snapshot.params['id'];
    this.contractNumber = _activatedRoute.snapshot.params['contractNumber'];
    this.queryNumber = _activatedRoute.snapshot.params['queryNumber'];
    this.financialInstitution =
      _activatedRoute.snapshot.params['financialInstitution'];
  }

  ngOnInit(): void {
    this.getRouteTitle();

    const modeSub = this._activatedRoute.firstChild?.params.subscribe(
      (params) => {
        this.currentMode = params['mode'] ?? 'visualizar';
        this._cd.detectChanges();
      }
    );

    if (modeSub) {
      this.subs.push(modeSub);
    }
  }

  ngAfterViewInit(): void {
    this.contractData = this._contractService.contractData;
    if (!this.isLotRoute()) {
      this.getContractStageName();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach((el) => {
      el.unsubscribe();
    });
  }

  getContractStageName(): void {
    this.stageName = this.contractData?.StageName || '';

    if (!this.stageName) {
      this.changeStage = false;
      this.changeCommission = false;
      this._cd.detectChanges();
      return;
    }

    const BATCH_STATUSES = {
      IN_PROGRESS: 'em andamento',
      CANCELED: 'cancelado'
    };

    const isBatchInProgressOrCanceled =
      !!this._contractService.batchDetailsInfo &&
      !!this._contractService.batchDetailsInfo.BatchStatus &&
      [BATCH_STATUSES.IN_PROGRESS, BATCH_STATUSES.CANCELED].includes(
        this._contractService.batchDetailsInfo.BatchStatus.toLowerCase()
      );

    this.changeStage =
      this.stageName === 'Apuracao' && isBatchInProgressOrCanceled;
    this.changeCommission = ['a estornar', 'apuracao'].includes(
      this.stageName.toLowerCase()
    );
    this._cd.detectChanges();
  }

  isLotRoute(): boolean {
    return (this.route || '').toLowerCase().includes('lote');
  }

  get showButton(): boolean {
    return (
      !this.isLotRoute() &&
      this.currentMode === 'editar' &&
      this.stageName === 'Entrada'
    );
  }

  get canEditContrato(): boolean {
    return (
      !this.isLotRoute() &&
      this.currentMode === 'visualizar' &&
      (this.stageName === 'Entrada' || this.changeStage)
    );
  }

  getRouteTitle() {
    this.route = String(this._activatedRoute.snapshot.routeConfig?.title);
  }

  saveForm(): void {
    let contract = {
      ...this._contractService.contractInfo,
      ...this._contractService.getForm().getRawValue()
    } as unknown as IGenericContract;

    contract = this.updateValueCustomField(contract);

    if (this.isLotRoute()) {
      const updateContractSub = this._contractService
        .updateContract(contract.ContractId, contract)
        .subscribe({
          next: (res) => {
            if (res) {
              const dialogData: IDialogConfirm = {
                type: DialogTypeEnum.Confirmation,
                appearance: 'modern',
                template: {
                  boldTitle: 'Sucesso',
                  title: 'Alterações salvas com sucesso!',
                  confirm: 'Ok'
                }
              };

              this._dialogService.openDialog(dialogData).then(() => {
                this._router.navigate(['/esteira-apuracao']);
              });
            }
          }
        });

      this.subs.push(updateContractSub);
      return;
    }

    const updateContractSub = this._contractService
      .updateContract(contract.ContractId, contract)
      .subscribe({
        next: (res) => {
          if (!res) {
            return;
          }

          const refetchSub = this._contractService
            .initializeForm(
              this.contractNumber,
              this.queryNumber,
              this.financialInstitution
            )
            .subscribe({
              next: () => {
                this.contractData = this._contractService.contractData;

                // Edicao nao altera o contrato direto: vira uma versao pendente de aprovacao.
                this._snackbarService.openSnackBar(
                  this.contractData?.Editing
                    ? 'Alteração enviada para aprovação'
                    : 'Alterações salvas com sucesso!',
                  'success',
                  3000
                );

                this.getContractStageName();
                this.navigateToMode('visualizar');
              }
            });

          this.subs.push(refetchSub);
        }
      });

    this.subs.push(updateContractSub);
  }

  cancelEdit(): void {
    const form = this._contractService.getForm();

    form.patchValue({
      Amount: this.contractData?.Amount,
      ContractDate: this.contractData?.ContractDate,
      Comments: this.contractData?.Comments
    });

    this.navigateToMode('visualizar');
  }

  enterEditMode(): void {
    const batchNumber = this._contractService.batchDetailsNumber;

    if (batchNumber) {
      const dialogData: IDialogConfirm = {
        type: DialogTypeEnum.Optional,
        appearance: 'modern',
        template: {
          boldTitle: 'Confirmar edição do contrato',
          title: `Ao editar o contrato ${this.contractData.Number}, o lote ${batchNumber} será cancelado e um novo lote será gerado após a aprovação da edição solicitada. Deseja prosseguir?`,
          confirm: 'Sim',
          dismiss: 'Não'
        }
      };

      this._dialogService.openDialog(dialogData).then((response) => {
        if (response) {
          this.proceedToEditMode();
        }
      });
      return;
    }

    this.proceedToEditMode();
  }

  private proceedToEditMode(): void {
    if (this.stageName === 'Entrada') {
      this.navigateToMode('editar');
      return;
    }

    const changeStageSub = this._contractService
      .changeStage(this._contractService.contractData.ContractId, 'Entrada')
      .subscribe({
        next: () => {
          this.stageName = 'Entrada';
          this.navigateToMode('editar');
        }
      });

    this.subs.push(changeStageSub);
  }

  private navigateToMode(mode: string): void {
    this._router.navigate(['../', mode], {
      relativeTo: this._activatedRoute.firstChild
    });
  }

  integrateSAP(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Integrar OMIE',
        title: 'Tem certeza que deseja integrar OMIE?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.integrateSapEvent.emit();
      }
    });
  }

  handleLiberarManual(): void {
    const dialogRef = this._dialog.open(LiberarManualDialogComponent, {
      data: { batchId: this.id },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.liberarManualEvent.emit({ payload: result.payload });
      }
    });
  }

  refreshNFENumber(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Reprocessar dados do OMIE',
        title: 'Tem certeza que deseja atualizar os dados de processamento do OMIE?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.refreshNFENumberEvent.emit();
      }
    });
  }

  reSendIntegrateSap(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Reintegrar com o OMIE',
        title: 'Tem certeza que deseja reintegrar este lote com o OMIE?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.reSendIntegrateSapEvent.emit();
      }
    });
  }

  requestInvoice(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Solicitar nota fiscal',
        title: 'Tem certeza que deseja solicitar NF?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.requestInvoiceEvent.emit();
      }
    });
  }

  //cancelSAP(): void {
  //  const dialogData: IDialogConfirm = {
  //    type: DialogTypeEnum.Optional,
  //    template: {
  //      title: '',
  //      textInit: 'Tem certeza que deseja ',
  //      boldTitle: 'cancelar OMIE?',
  //      confirm: 'sim',
  //      dismiss: 'não',
  //      boldWord: ''
  //    }
  //  };

  //  this._dialogService.openDialog(dialogData).then((response) => {
  //    if (response) {
  //      this.cancelSapEvent.emit();
  //    }
  //  });
  //}

  cancelBatch(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Cancelar lote',
        title: 'Tem certeza que deseja cancelar o lote?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.cancelBatchEvent.emit(true);
      }
    });
  }

  cancelAllContractsBatchDialogOpen(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Cancelar lote',
        title: 'Este lote será cancelado. Você deseja criar um novo lote?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response === true) {
        this.cancelAllContractsBatchEvent.emit(true);
      } else if (response === false) {
        this.cancelAllContractsBatchEvent.emit(false);
      }
    });
  }

  returnBatchStatus(): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Voltar status do lote',
        title: 'Tem certeza que deseja voltar o status do lote para "Em Andamento"?',
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.returnBatchStatusEvent.emit(true);
      }
    });
  }

  getBatchEventLogs(): void {
    this.viewBatchEventLogEvent.emit();
  }

  updateValueCustomField(contract: IGenericContract): IGenericContract {
    contract.ContractCustomFields.forEach((field) => {
      let value = contract[field.FieldName] as string;
      field.Value = value;
      field.Label = '';
      delete contract[field.FieldName];
    });

    delete contract['TransferBeneficiaries'];
    delete contract['InvoiceBeneficiaries'];
    delete contract['BatchDetails'];
    delete contract[''];

    contract.Beneficiaries.forEach((i) => {
      delete i['Amount'];
      delete i.PaymentDate;
      delete i.EstimatedPaymentDate;
    });

    return contract;
  }
}
